import { render } from "./newsModal.vue?vue&type=template&id=0b54a700&scoped=true"
import script from "./newsModal.vue?vue&type=script&lang=js"
export * from "./newsModal.vue?vue&type=script&lang=js"

import "./newsModal.vue?vue&type=style&index=0&id=0b54a700&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b54a700"]])

export default __exports__